import React, { useState } from "react";
import useForm from './hooks/useForm';
import { FormField, Button, LoadingIcon } from '@prosolve/common-components-ui'
import useFetch from './hooks/useFetch';
import background from './images/background-blue.png';
import useMediaQuery from './hooks/useMediaQuery';
import { useNavigate } from "react-router-dom";
import { getClientSubdomain } from './utils';

export default () => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  const id = urlParams.get('id');

  const navigate = useNavigate();

  const isSmallView = useMediaQuery('(max-width: 620px)');

  const clientSubdomain = getClientSubdomain()
      
  const isStarSubdomain = (clientSubdomain === 'star')

  const fetch = useFetch();

  const [isBusy, setIsBusy] = useState(false);
  const [showInvalidLogin, setShowInvalidLogin] = useState('');

  const formSchema = {
    requiredFields: ['password', 'confirmPassword'],
    initData: {
      password: '',
    }
  }

  const formData = useForm(formSchema)

  const onClickSubmit = async () => {
    if (formData.isValid() && formData.values.password === formData.values.confirmPassword ) {
      setIsBusy(true)

      const postObj = {
        ...formData.values,
        token,
        id
      }

      const response = await fetch(
        `auth/resetPassword`,
        {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(postObj)
        }
      )

      const jsonData = await response.json() || {};

      const { status = '' } = jsonData;

      if (status) {
        navigate('/')
      } else {
        setShowInvalidLogin('An error has occured')
      }

      setIsBusy(false)
    } else {
      if (formData.values.password !== formData.values.confirmPassword) {
        setShowInvalidLogin('Passwords do not match')
      }
    }
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      onClickSubmit();
    }
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: isSmallView ? 'column' : 'row',
      rowGap: '15px',
      // padding: '20px',
      height: '100%',
      boxSizing: 'border-box',
      overflow: 'auto',
      overflowX: 'hidden',
      // background: '#ffffff'
      background: isStarSubdomain ? `url(${'https://starautismsupport.com/sites/default/files/SAS%20Background-%20light%20bg-2.png'})  top left/cover no-repeat fixed` : `url(${background})  top left/cover no-repeat fixed`
    }}>

      <div style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: isSmallView ? 'flex-start' : 'center',
        alignItems: 'center',
        padding: '20px',
        zIndex: '100',
        marginTop: isSmallView ? '-15px' : '0px'
      }}>

        <div style={{ display: 'flex', flexDirection: 'column' }}>

          <div style={{ flex: 1, display: 'flex', marginBottom: '20px', textAlign: isSmallView ? 'center' : 'center' }}>
            <div style={{ color: isStarSubdomain ? '#225aa8' : '#ffffff' }}>
              <div style={{ fontWeight: 'bold', fontSize: '40px', marginBottom: '40px' }}>{"Reset Password"}</div>
              <div style={{ fontSize: '26px', maxWidth: isSmallView ? 'none' : '600px' }}>
                {"Create your new password below"}
              </div>
            </div>
          </div>

          <FormField
            fieldStyle={{
              fontSize: '18px',
              textAlign: isSmallView ? 'center' : 'left',
            }}
            label='Password'
            labelStyle={{ color: isStarSubdomain ? '#225aa8' : '#ffffff', fontWeight: 'bold' }}
            fieldId='password'
            type='password'
            // placeholder='Email'
            formData={formData}
            onKeyDown={onKeyDown}
          />

          <div style={{ marginTop: '10px' }}>&nbsp;</div>

          <FormField
            fieldStyle={{
              fontSize: '18px',
              textAlign: isSmallView ? 'center' : 'left',
            }}
            label='Confirm Password'
            labelStyle={{ color: isStarSubdomain ? '#225aa8' : '#ffffff', fontWeight: 'bold' }}
            fieldId='confirmPassword'
            type='password'
            // placeholder='Password'
            formData={formData}
            onKeyDown={onKeyDown}
          />

          <div style={{ height: '25px', position: 'relative' }}>

            {
              (!isBusy && Boolean(showInvalidLogin)) ?
                <div style={{
                  color: '#ef0c0c',
                  fontStyle: 'italic',
                  fontSize: '14px',
                  position: 'absolute',
                  top: '3px',
                  left: '3px'
                }}>
                  {showInvalidLogin}
                </div>
                :
                <div>&nbsp;</div>
            }

          </div>

          <div style={{ display: 'flex', alignItems: 'center', justifyContent: isSmallView ? 'center' : 'center' }}>
            <Button
              style={{
                display: 'inline-flex',
                marginRight: '10px',
                fontWeight: 'bold',
                fontSize: '24px',
                width: '150px',
                height: '40px',
                color: isStarSubdomain ? '#ffffff' : '#ffffff',
                background: isStarSubdomain ? '#f57d49' : 'transparent'
              }}
              onClick={onClickSubmit}
              $colored={true}
            >
              {'SUBMIT'}
            </Button>
            {
              isBusy &&
              <LoadingIcon />
            }
          </div>

        </div>
      </div>
    </div>
  )
}